import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FaqHero from './components/FaqHero';
import FaqAccordion from './components/FaqAccordion';
import FaqConsultBanner from './components/FaqConsultBanner';
import FaqCta from './components/FaqCta';

export default function FaqPage() {
  return (
    <div className="min-h-screen bg-[#fafaf8]">
      <Navbar />
      <main>
        <FaqHero />
        <FaqAccordion />
        <FaqConsultBanner />
        <FaqCta />
      </main>
      <Footer />
    </div>
  );
}
